import { lazy, Suspense } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Loading from "../components/common/Loading";
import { MAIN_PATHS } from "./urls";

interface ComponentProps {
  childComp?: React.ReactNode;
}

const Loadable = (Component: React.FC<ComponentProps>) => (props: ComponentProps) => {
  return (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );
};

function MainRoutes() {
  let routes = useRoutes([
    { path: "*",
      element: <NotFound /> ,
    },
    {
      path: '/',
      element: <MainLayout hasFooter={true} />,
      children: [{ path: "", element: <Home /> }],
    },
        {
      path: '/public-viewer',
      element: <MainLayout hasFooter={true} />,
      children: [{ path: "", element: <PublicViewer /> }],
    },
    // {
    //   path: MAIN_PATHS.viewer,
    //   element: <MainLayout hasFooter={false} />,
    //   children: [{ path: ":id", element: <Viewer /> }],
    // },
  ]);
  return routes;
}
export default MainRoutes;

const Home = Loadable(lazy(() => import("../pages/Home")));
const NotFound = Loadable(lazy(() => import("../pages/NotFound")));
const PublicViewer = Loadable(lazy(() => import("../pages/PublicViewer")));
// const Viewer = Loadable(lazy(() => import("@/pages/Viewer")));
